'use client';

import { useUser } from '@auth0/nextjs-auth0/client';
import { usePathname } from 'next/navigation';
import React from 'react';

import useComments from '../model';

export default function CommentForm({ locatedFor }: { locatedFor: 'post' | 'publication' }) {
  const { text, setText, onSubmit } = useComments({ locatedFor });
  const { user } = useUser();
  const path = usePathname();

  return (
    <form onSubmit={onSubmit}>
      <textarea
        className="flex max-h-40 w-full resize-y rounded bg-gray-300 p-3 text-gray-900 placeholder-gray-500"
        rows={2}
        placeholder={
          user
            ? `Оставить комментарий`
            : 'Пожалуйста войдите в систему, чтобы оставить комментарии.'
        }
        onChange={(e) => setText(e.target.value)}
        value={text}
        disabled={!user}
      />

      <div className="mt-4 flex items-center">
        {user ? (
          <div className="flex w-full justify-end space-x-6">
            <button
              type="submit"
              className="rounded bg-emerald-600 px-4 py-2 text-white hover:bg-emerald-700 disabled:opacity-40"
            >
              Отправить
            </button>
          </div>
        ) : (
          <div className="flex w-full justify-end space-x-6">
            <a
              className="flex transform rounded-md bg-yellow-400 px-4 py-2 transition-transform active:scale-95 dark:bg-yellow-600"
              href={`/auth/login?last-visited=${path}`}
            >
              Войти
            </a>
          </div>
        )}
      </div>
    </form>
  );
}
